<template>
  <div id="contenedor-main-reportes-contratos-consulta">
    <!-- ToolBar -->
    <div>
      <tool-bar
        :listaContratos="getContratos"
        :filtros="filtros">
      </tool-bar>
    </div>
    <!-- Loader -->
    <v-skeleton-loader
      v-if="$apollo.loading"
      type="table-heading, table-thead, table-tbody">
    </v-skeleton-loader>
    <div>
    </div>
    <listado
      v-if="!$apollo.loading"
      :listado="listadoContratos">
    </listado>
  </div>
</template>

<script>
import CONTRATOS from '@/graphql/querys/administracion/contratos/contratosReportesConsulta.gql';
import mixAvProgramado from '@/helpers/calculos/mixAvProgramado';
import mixAvanceFinanciero from '@/helpers/calculos/mixAvanceFinanciero';
import ToolBar from './ToolBar.vue';
import Listado from './listado/Main.vue';

export default {
  name: 'DefaultReportesContratosConsulta',
  mixins: [mixAvProgramado, mixAvanceFinanciero],
  components: {
    ToolBar,
    Listado,
  },
  data() {
    return {
      buscarTexto: '',
      filtros: {
        ejercicio: new Date().getFullYear(),
        buscarTexto: '',
        tipos: [],
        financiamiento: 'Todos',
        programas: [],
        contratistas: [],
        supervisores: [],
        guardarFiltros: false,
      },
    };
  },
  apollo: {
    contratosReportesConsulta: {
      query: CONTRATOS,
      variables() {
        let ejercicio = new Date().getFullYear();
        let periodo = 1;

        if (typeof this.filtros.ejercicio === 'string') {
          const split = this.filtros.ejercicio.split('-');
          ejercicio = Number(split[0]);
          periodo = Number(split[1]);
        } else {
          ejercicio = Number(this.filtros.ejercicio);
        }
        return ({
          ejercicio,
          periodo,
        });
      },
    },
  },
  mounted() {
    const filtrosGuardados = JSON.parse(this.mixGetFiltro('consulta-contratos'));
    if (filtrosGuardados) {
      this.filtros = JSON.parse(this.mixGetFiltro('consulta-contratos'));
    }
  },
  computed: {
    getContratos() {
      if (!this.contratosReportesConsulta) return [];
      return this.contratosReportesConsulta
      // Separar el tipo de obra
        .map((contrato) => {
          const [obra] = contrato.obras;

          return {
            ...contrato,
            obra: obra || null,
          };
        });
    },
    listadoContratos() {
      if (!this.contratosReportesConsulta) return [];
      const contratos = this.contratosReportesConsulta;
      const nuevosContratos = contratos.map((contrato) => contrato);
      return nuevosContratos
        // Separar el tipo de obra
        .map((contrato) => {
          const [obra] = contrato.obras;

          return {
            ...contrato,
            obra: obra || null,
          };
        })
        // Sumar el total de anticipo
        .map((contrato) => ({
          ...contrato,
          totalAnticipo: contrato.anticipos.reduce((val, { total }) => val + total, 0),
        }))
        .map((contrato) => {
          const avanceProgramado = this.mixCalcularAvanceProgramado(new Date()
            .toISOString().slice(0, 10),
          contrato);
          const avanceFinanciero = this.mixCalcularPorcentajeFinanciero(contrato);
          const avanceDiferencia = ((avanceProgramado.porcentaje) - avanceFinanciero);

          return {
            ...contrato,
            avanceProgramado,
            avanceFinanciero,
            avanceDiferencia,
          };
        })
        // Sacar el ultimo reporte
        .map((contrato) => {
          const ultimoReporte = contrato.reportesFisicos[0];

          if (ultimoReporte) {
            ultimoReporte.avanceDiferencia = (contrato.avanceProgramado
            - ultimoReporte.avanceFisico);
          }

          return {
            ...contrato,
            ultimoReporte,
          };
        })
        // poner la supervision externa
        .map((contrato) => ({
          ...contrato,
          supervisionExterna: contrato.contratosRelacionados
            .find(({ esSupervisionExterna }) => esSupervisionExterna === true),
        }))
        .slice()
        .sort((a, b) => new Date(b.fecha) - new Date(a.fecha))
        // Por tipo de obra
        .filter(({ obra }) => {
          if (this.filtros.tipos.length <= 0) return true;
          if (obra === null && this.filtros.tipos.length > 0) return false;
          const idTipo = obra.obra.tipo.id;

          return this.filtros.tipos.includes(idTipo);
        })
        // Filtrar por tipo de contrato
        .filter(({ esObraFinanciada }) => {
          if (this.filtros.financiamiento === 'Todos') return true;

          if (this.filtros.financiamiento === 'Normal') return esObraFinanciada === false;

          return esObraFinanciada === true;
        })
        // Programa de obra
        .filter(({ obra }) => {
          if (this.filtros.programas.length <= 0) return true;
          if (obra === null && this.filtros.programas.length > 0) return false;
          const idPrograma = obra.obra.programa.id;

          return this.filtros.programas.includes(idPrograma);
        })
        // Filtro por contratista
        .filter(({ idContratista }) => {
          const { contratistas } = this.filtros;
          if (contratistas.length <= 0) return true;

          return contratistas.includes(idContratista);
        })
        // Filtro por supervisor
        .filter(({ responsables }) => {
          const responsablesaFiltrados = responsables.map(({ idFuncionario }) => idFuncionario);
          const { supervisores } = this.filtros;
          if (supervisores.length <= 0) return true;

          return supervisores.some((id) => responsablesaFiltrados.includes(id));
        })
        .filter((contrato) => {
          if (!this.filtros.buscarTexto) return contrato;
          const expt = new RegExp(this.filtros.buscarTexto, 'gi');
          const numero = this.$normalizacionTexto(contrato.numero);
          const meta = this.$normalizacionTexto(contrato.meta);
          const contratista = this.$normalizacionTexto(
            contrato.contratista.nombreRazonSocial,
          );
          return (
            expt.test(numero)
            || expt.test(meta)
            || expt.test(contratista)
            || expt.test(contrato.numero)
            || expt.test(contrato.meta)
            || expt.test(contrato.contratista.nombreRazonSocial)
          );
        })
        .sort((a, b) => {
          if (!a.ultimoReporte) return true;
          return b.ultimoReporte?.avanceProgramado - a.ultimoReporte?.avanceProgramado;
        })
        .sort((a, b) => {
          if (!a.ultimoReporte) return true;
          return b.ultimoReporte?.avanceDiferencia - a.ultimoReporte?.avanceDiferencia;
        });
    },
  },
  watch: {
    filtros: {
      handler(filtros) {
        if (filtros.guardarFiltros) {
          this.mixGuardarFiltros('consulta-contratos', JSON.stringify(filtros));
        } else {
          this.mixRemoverFiltro('consulta-contratos');
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss">

</style>
